import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';
import { getSection } from '../../../../../services/api';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: [],
    };

    async componentDidMount() {
        try {
            const {
                content: { base62Id, searchPath },
            } = this.props;

            const data = await getSection(base62Id, searchPath);

            this.setState({
                data,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { data } = this.state;
        const {
            content: { rightAd },
        } = this.props;

        return (
            <div className={styles.rightContent}>
                <div className={styles.list}>
                    <div className={styles.title}>往期回顾</div>
                    <ul>
                        {data.map((item, index) => (
                            <li key={index}>
                                <a href={item.url} target="_blank" title={item.title}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.ad_box}>
                    <Ad content={rightAd} />
                </div>
            </div>
        );
    }
}

export default RightContent;
